// libraries
import type { DocMoveState, DocMoveWsEvent, StateTree } from '@makemydeal/dr-dash-types';

export const getDocMoveState = (state: StateTree): DocMoveState => {
    return state.docMove || ({ wsEvent: null } as DocMoveState);
};

export const getDocMoveWsEvent = (state: StateTree): DocMoveWsEvent | null => {
    return getDocMoveState(state).wsEvent;
};
